import React from 'react';

const SearchForm = ({ sport, setSport, date, setDate, loading, onSearch }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: '30px', display: 'flex', gap: '15px', justifyContent: 'center', alignItems: 'end' }}>
      <div>
        <label htmlFor="sport" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
          Sport:
        </label>
        <select
          id="sport"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
        >
          <option value="nfl">NFL</option>
          <option value="basketball">Basketball</option>
          <option value="soccer">Soccer</option>
          <option value="baseball">Baseball</option>
        </select>
      </div>
      
      <div>
        <label htmlFor="date" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
          Date:
        </label>
        <input
          type="date"
          id="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>
      
      <button
        type="submit"
        disabled={loading}
        style={{
          padding: '8px 16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? 'Searching...' : 'Search'}
      </button>
    </form>
  );
};

export default SearchForm;
